const $inject = ['$q', 'moment', 'itinerariesService', 'settingsService', 'ENUMS', 'dateTimeService', 'lbDialogService'];

const searchFormService = function ($q, moment, itinerariesService, settingsService, ENUMS, dateTimeService, lbDialogService) {
  let service = {
    activeSearchTypes: {
      Flights: { active: false, showForm: false, enabled: true },
      Hotels: { active: false, showForm: false, enabled: true },
      Cars: { active: false, showForm: false, enabled: true },
      Rail: { active: false, showForm: false, enabled: true },
      Ground: { active: false, showForm: false, enabled: true },
    },
    railOptions: {
      return: true,
      openReturn: false,
    },
    flightLegs: 2,
    updateSearchChoices,
    updateFlightLegs,
    updateRailReturn,
    updateRailOpenReturn,
    validateThenPostForm,
    prepRailFormData,
    prepCarFormData,
    prepHotelFormData,
    getLocationCodeHotel,
    prepGroundFormData,
    getFlightData,
    getRailLocationName,
    lbDialogService,
  };

  const DATE_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);
  const TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
  const DATE_FORMAT_API = 'YYYY-MM-DD[T]HH:mm:ss';

  function prepCarFormData(searchForm) {
    const pickUpDate = searchForm.pickUpDate.$modelValue;
    const pickUpTime = searchForm.pickUpTime.$modelValue;
    const pickUpDateTime = moment(pickUpDate + pickUpTime, DATE_FORMAT + TIME_FORMAT).format(DATE_FORMAT_API);

    const dropOffDate = searchForm.dropOffDate.$modelValue;
    const dropOffTime = searchForm.dropOffTime.$modelValue;
    const dropOffDateTime = moment(dropOffDate + dropOffTime, DATE_FORMAT + TIME_FORMAT).format(DATE_FORMAT_API);

    const hideDropOff = searchForm.hideDropOff.$modelValue;
    const pickupPoi = searchForm.selectCarPickUpLocation.$modelValue;
    let dropoffPoi = searchForm.dropOffLocation.$modelValue;

    const pickUpOtherLocation = searchForm.pickUpOtherLocation ? searchForm.pickUpOtherLocation.$modelValue : undefined;
    let dropOffOtherLocation = searchForm.dropOffOtherLocation ? searchForm.dropOffOtherLocation.$modelValue : undefined;
    if (hideDropOff === true) {
      dropoffPoi = pickupPoi;
      dropOffOtherLocation = pickUpOtherLocation;
    }
    const searchObject = {
      PickUp: generateCarSearchPayload(pickUpDateTime, pickupPoi, pickUpOtherLocation),
      DropOff: generateCarSearchPayload(dropOffDateTime, dropoffPoi, dropOffOtherLocation),
    };

    return searchObject;
  }
  /**
   * This is called before HotelSearchController
   * i.e. It's only called when performing another search from the Hotel search page
   * @param {*} searchForm
   */
  function prepHotelFormData(searchForm, locationInput = null) {
    let checkInDate = searchForm.checkInDate.$modelValue;
    let checkOutDate = searchForm.checkOutDate.$modelValue;
    let location = searchForm.hotelLocation.$modelValue || locationInput;
    let radius = searchForm.radius ? searchForm.radius.$modelValue.value : 15;

    let payload = generateHotelSearchPayload(checkInDate, checkOutDate, location, radius);
    return payload;
  }
  /**
   * Generates payload, defaulting in some values from location
   * @param {*} checkInDate
   * @param {*} checkOutDate
   * @param {*} location
   * @param {*} radius
   */
  function generateHotelSearchPayload(checkInDate, checkOutDate, location, radius) {
    let checkIn = moment(checkInDate, DATE_FORMAT).format(DATE_FORMAT_API);
    let checkOut = moment(checkOutDate, DATE_FORMAT).format(DATE_FORMAT_API);

    return {
      DateFrom: checkIn,
      DateTo: checkOut,
      Location: {
        City: location.City ? location.City.Name : '',
        Country: location.Country ? location.Country.Name : '',
        CountryCode: location.Country ? location.Country.Code : '',
        Location: location.Address,
        IsInternational: '',
        Code: getLocationCodeHotel(location), // Iata is used for POI lookup, code is used with airport lookup
        Name: location.Title,
        Type: location.Type,
        Latitude: location.Latitude,
        Longitude: location.Longitude,
        RadiusDistance: radius,
      },
    };
  }
  function generateCarSearchPayload(dateValue, location, OtherLocation) {
    let ret = {
      Date: dateValue,
      Location: location.Title,
      Code: location.Iata,
      IsInternational: '',
      City: location.City ? location.City.Name : '',
      CityCode: location.City ? location.City.Code : '',
      Country: location.Country ? location.Country.Name : '',
      CountryCode: location.Country ? location.Country.Code : '',
      IsInternational: '',
      Name: location.Title,
      Type: location.Type,
      Latitude: location.Latitude,
      Longitude: location.Longitude,
    };

    if (OtherLocation && location.Type !== 'Airport') {
      let depot = {};

      depot.Address = OtherLocation.addressLabel;
      depot.Code = OtherLocation.code;
      depot.FullCode = OtherLocation.fullCode;
      depot.Supplier = OtherLocation.supplierId;
      ret.Depot = depot;
      ret.Code = OtherLocation.fullCode;
      if (OtherLocation.fullCode && OtherLocation.fullCode.length > 3) {
        ret.Code = OtherLocation.fullCode.substr(0, 3);
      }
      ret.CityCode = ret.Code;

      ret.Location = OtherLocation.addressLabel;
    }

    return ret;
  }
  /**
   * Based on different types of locations, get 3-letter code relevant to hotel search
   * @param {location object} location
   */
  function getLocationCodeHotel(location) {
    if (location.City && location.City.Code) {
      return location.City.Code;
    }

    if (location.Iata) {
      return location.Iata;
    }

    return location.Code;
  }
  function updateSearchChoices(choice) {
    const t = service.activeSearchTypes;
    const r = service.railOptions;

    switch (choice) {
      case 'Flights':
        if (!t.Rail.active && !t.Hotels.active && !t.Cars.active) {
          t.Flights.active = true;
          t.Flights.showForm = true;
        } else {
          t.Flights.active = !t.Flights.active;
          t.Flights.showForm = !t.Flights.showForm;
        }

        if (t.Flights.active) {
          r.openReturn = false;
          r.return = true;

          t.Rail.active = false;
          t.Rail.showForm = false;
          t.Hotels.showForm = false;
          t.Cars.showForm = false;
        } else {
          t.Hotels.showForm = t.Hotels.active;
          t.Cars.showForm = t.Cars.active;
        }

        if ((t.Cars.active || t.Hotels.active) && service.flightLegs === 1) {
          t.Cars.active = t.Cars.active;
          t.Cars.showForm = t.Cars.active;
          t.Hotels.active = t.Hotels.active;
          t.Hotels.showForm = t.Hotels.active;
          t.Flights.active = t.Flights.active;
          t.Flights.showForm = t.Flights.active;
        }

        if (t.Flights.active || t.Rail.active || t.Hotels.active || t.Cars.active) {
          t.Ground.active = false;
          t.Ground.showForm = false;
        }
        break;

      case 'Rail':
        if (!t.Flights.active && !t.Hotels.active && !t.Cars.active) {
          t.Rail.active = true;
          t.Rail.showForm = true;
        } else {
          t.Rail.active = !t.Rail.active;
          t.Rail.showForm = !t.Rail.showForm;
        }

        if (t.Rail.active) {
          t.Flights.active = false;
          t.Flights.showForm = false;
          t.Hotels.showForm = false;
          t.Cars.active = false;
          t.Cars.showForm = false;
        } else {
          t.Hotels.showForm = t.Hotels.active;
        }

        if (service.railOptions.openReturn) {
          t.Hotels.active = false;
          t.Hotels.showForm = false;
        }

        if (t.Flights.active || t.Rail.active || t.Hotels.active || t.Cars.active) {
          t.Ground.active = false;
          t.Ground.showForm = false;
        }
        break;

      case 'Hotels':
        const hotelActive = t.Hotels.active;

        if (!t.Flights.active && !t.Rail.active && !t.Cars.active) {
          t.Hotels.active = true;
          t.Hotels.showForm = true;
        } else {
          t.Hotels.active = !t.Hotels.active;
          t.Hotels.showForm = !t.Hotels.showForm;
        }

        if (t.Flights.active) {
          t.Hotels.showForm = false;
        }

        if (!t.Cars.active && service.flightLegs === 1) {
          t.Hotels.active = t.Hotels.active;
          t.Hotels.showForm = t.Hotels.active;
        }

        if (t.Flights.active && service.flightLegs === 1) {
          t.Hotels.active = t.Hotels.active;
          t.Hotels.showForm = t.Hotels.active;
          t.Flights.active = t.Flights.active;
          t.Flights.showForm = true;
        }

        if (t.Rail.active) {
          t.Hotels.active = true;
          t.Hotels.showForm = true;
          if (!r.return || r.openReturn) {
            r.openReturn = false;
            r.return = true;
            t.Rail.active = false;
            t.Rail.showForm = false;
            t.Hotels.active = true;
            t.Hotels.showForm = true;
          } else {
            if (hotelActive) {
              t.Hotels.active = false;
              t.Hotels.showForm = false;
            } else {
              t.Hotels.active = true;
              t.Hotels.showForm = false;
            }
          }
        }

        if (t.Flights.active || t.Rail.active || t.Hotels.active || t.Cars.active) {
          t.Ground.active = false;
          t.Ground.showForm = false;
        }
        break;

      case 'Cars':
        if (!t.Flights.active && !t.Rail.active && !t.Hotels.active) {
          t.Cars.active = true;
          t.Cars.showForm = true;
        } else {
          t.Cars.active = !t.Cars.active;
          t.Cars.showForm = !t.Cars.showForm;
        }

        if (t.Flights.active || t.Rail.active) {
          t.Cars.showForm = false;
        }

        if (t.Rail.active) {
          r.openReturn = false;
          r.return = true;
          t.Rail.active = false;
          t.Rail.showForm = false;
          t.Cars.active = true;
          t.Cars.showForm = true;
          t.Hotels.showForm = t.Hotels.active;
        }

        if (t.Flights.active && service.flightLegs === 1) {
          t.Cars.active = t.Cars.active;
          t.Cars.showForm = t.Cars.active;
          t.Flights.active = true;
          t.Flights.showForm = true;
        }

        if (t.Flights.active || t.Rail.active || t.Hotels.active || t.Cars.active) {
          t.Ground.active = false;
          t.Ground.showForm = false;
        }

        break;
      case 'Ground':
        if (!t.Flights.active && !t.Rail.active && !t.Hotels.active && !t.Cars.active) {
          t.Ground.active = true;
          t.Ground.showForm = true;
        } else {
          t.Ground.active = !t.Ground.active;
          t.Ground.showForm = !t.Ground.showForm;
        }

        if (t.Ground.active) {
          t.Flights.active = false;
          t.Flights.showForm = false;
          t.Rail.active = false;
          t.Rail.showForm = false;
          t.Hotels.active = false;
          t.Hotels.showForm = false;
          t.Cars.active = false;
          t.Cars.showForm = false;
        }

        break;
      default:
        console.warn('NO CART ITEM TYPE FOUND!');
    }
  }
  function updateFlightLegs(legs) {
    const t = service.activeSearchTypes;
    service.flightLegs = legs;

    if (t.Flights.active) {
      if (service.flightLegs <= 1) {
        t.Hotels.active = t.Hotels.active;
        t.Hotels.showForm = t.Hotels.active;
        t.Cars.active = t.Cars.active;
        t.Cars.showForm = t.Cars.active;
      }

      if (service.flightLegs > 1) {
        t.Hotels.active = t.Hotels.active;
        t.Hotels.showForm = false;
        t.Cars.active = t.Cars.active;
        t.Cars.showForm = false;
      }
    }
  }
  function updateRailReturn() {
    const t = service.activeSearchTypes;

    if (!service.railOptions.return) {
      t.Hotels.active = false;
      t.Hotels.showForm = false;
      t.Cars.active = false;
      t.Cars.showForm = false;
    }
  }
  function updateRailOpenReturn() {
    const t = service.activeSearchTypes;

    if (service.railOptions.openReturn) {
      t.Hotels.active = false;
      t.Hotels.showForm = false;
    }
  }
  function validateThenPostForm(searchForm, travellers) {
    let DATE_FORMAT_MEDIUM = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM).replace(',', '[,]');

    let deferred = $q.defer();

    if (searchForm.$invalid) {
      deferred.reject();
    }

    const t = service.activeSearchTypes;

    let orderNumber = searchForm.orderNumber ? searchForm.orderNumber.$modelValue : undefined;
    if (orderNumber) {
      orderNumber = orderNumber.hasOwnProperty('Value') ? orderNumber.Value : orderNumber;
    }

    let searchParams = {
      search: {
        Passengers: travellers,
        Reason: searchForm.reasonForTravel ? searchForm.reasonForTravel.$modelValue.Value : undefined,
        OrderNumber: orderNumber,
        IsMultiPaxPnr: searchForm.IsMultPaxPnr && searchForm.IsMultPaxPnr.$modelValue === true ? true : false,
      },
    };
    if (t.Flights.showForm) {
      let flightsAmount = searchForm.flightSearch.flightsAmount.$modelValue;

      for (let i = 0; i < flightsAmount; i++) {
        let flightDate = searchForm.flightSearch['flight' + (i + 1) + 'Date'].$modelValue;
        let flightTime = searchForm.flightSearch['flight' + (i + 1) + 'Time'].$modelValue;
        let flightDateTime = moment(flightDate + flightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format(DATE_FORMAT_API);

        let destination = searchForm.flightSearch['flight' + (i + 1) + 'Arrival'].$modelValue;
        let destinationCode = destination.Value;
        let destinationName = destination.City + ', ' + destination.Country;
        let originCode = searchForm.flightSearch['flight' + (i + 1) + 'Departure'].$modelValue.Value;

        searchParams = addFlight(searchParams, flightDateTime, originCode, destinationCode);

        if (t.Hotels.active && flightsAmount > 0) {
          let checkOut;
          let checkIn;

          if (i != flightsAmount - 1) {
            checkOut = searchForm.flightSearch['flight' + (i + 2) + 'Date'].$modelValue;
            checkIn = flightDate;

            let location = {
              Title: destinationName,
              Code: destinationCode,
              Type: 'Airport',
            };

            let selectedLocation = location;

            if (searchForm.hotelLocation && searchForm.hotelLocation.$modelValue) {
              const hotelLocation = searchForm.hotelLocation.$modelValue;
              if (hotelLocation.Iata !== location.Code || hotelLocation.Type !== location.Type) {
                selectedLocation = hotelLocation;
              }
            }

            searchParams = addHotel(searchParams, checkIn, checkOut, selectedLocation);

            if (searchForm.radius && searchForm.radius.$modelValue && searchForm.radius.$modelValue.value) {
              searchParams.search.Hotels[0].Location.RadiusDistance = searchForm.radius.$modelValue.value;
            }
          }
        }

        if (t.Cars.active && flightsAmount > 0) {
          let nextFlightDate;
          let nextFlightTime;
          let dropOffDateTime = `${searchForm.dropOffDate.$modelValue} ${searchForm.dropOffTime.$modelValue}`;
          let dropOffCode;

          if (i != flightsAmount - 1) {
            nextFlightDate = searchForm.flightSearch['flight' + (i + 2) + 'Date'].$modelValue;
            nextFlightTime = searchForm.flightSearch['flight' + (i + 2) + 'Time'].$modelValue;
            dropOffDateTime = moment(nextFlightDate + nextFlightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format(DATE_FORMAT_API);
            dropOffCode = searchForm.flightSearch['flight' + (i + 2) + 'Departure'].$modelValue.Value;

            let searchObject = {
              PickUp: {
                Date: flightDateTime,
                Code: destinationCode,
                Name: destinationName,
              },
              DropOff: {
                Date: dropOffDateTime,
                Code: dropOffCode,
              },
            };

            searchParams = addCar(searchParams, searchObject);
          }
        }
      }
    }

    if (t.Rail.showForm) {
      searchParams = service.prepRailFormData(searchForm, searchParams);

      if (t.Hotels.active) {
        const checkIn = searchForm.outboundDate.$modelValue;
        const checkOut = searchForm.returnDate
          ? searchForm.returnDate.$modelValue
          : moment(checkIn, DATE_FORMAT).add(1, 'd').format(DATE_FORMAT);

        let selectedLocation = searchForm.railTo1 && searchForm.railTo1.$modelValue;

        if (searchForm.hotelLocation && searchForm.hotelLocation.$modelValue) {
          selectedLocation = searchForm.hotelLocation.$modelValue;
        }

        if (selectedLocation) {
          searchParams = addHotel(searchParams, checkIn, checkOut, selectedLocation);
        }

        if (searchForm.radius && searchForm.radius.$modelValue && searchForm.radius.$modelValue.value) {
          searchParams.search.Hotels[0].Location.RadiusDistance = searchForm.radius.$modelValue.value;
        }
      }
    }

    if (t.Hotels.showForm) {
      let checkInDate = searchForm.checkInDate.$modelValue;
      let checkOutDate = searchForm.checkOutDate.$modelValue;
      searchParams = addHotel(searchParams, checkInDate, checkOutDate, searchForm.hotelLocation.$modelValue);
      try {
        searchParams.search.Hotels[0].Location.RadiusDistance = searchForm.radius.$modelValue.value;
      } catch (e) {}
    }

    if (t.Cars.showForm) {
      let searchObject = prepCarFormData(searchForm);
      searchParams = addCar(searchParams, searchObject);
    }

    if (t.Ground.showForm) {
      let searchObject = prepGroundFormData(searchForm);
      searchParams = addGround(searchParams, searchObject);
    }

    searchParams.search.CompanyReferences = addCompanyReferences(searchForm);

    itinerariesService
      .post(searchParams)
      .then((itineraryResponse) => {
        deferred.resolve(itineraryResponse);
      })
      .catch((err) => {
        deferred.reject();
        if (err == undefined) {
          lbDialogService
            .show({
              title: 'Internal Error',
              message: 'There was an error creating the Itinerary. Please refresh the page.',
              warningLevel: 'warning',
              showCancelButton: false,
              submitButtonText: 'Refresh Page',
            })
            .then(function () {
              location.reload(true);
            });
        }
      });

    return deferred.promise;
  }
  function addCompanyReferences(searchForm) {
    let i = 0;
    let ret = [];
    while (searchForm['companyReference_code_' + i]) {
      let reference = searchForm['companyReference_code_' + i].$modelValue;
      let item = {
        Code: reference.Code,
        Title: reference.Title,
        ValueDescription: reference.Value,
        Value: reference.Value,
        PlacementType: 'HomeSearch',
      };
      if (reference.ValueDescription && reference.ValueDescription.Description) {
        item.ValueDescription = reference.ValueDescription.Description;
        item.Value = reference.ValueDescription.Value;
      }
      ret.push(item);
      i++;
    }

    return ret;
  }
  function getFlightData(searchForm) {
    let flights = [];
    for (let i = 0; i < searchForm.flightSearch.flightsAmount.$modelValue; i++) {
      flights.push(prepFlightData(searchForm, i));
    }
    return flights;
  }
  function prepFlightData(searchForm, i) {
    let DATE_FORMAT_MEDIUM = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM).replace(',', '[,]');
    let flightDate = searchForm.flightSearch['flight' + (i + 1) + 'Date'].$modelValue;
    let flightTime = searchForm.flightSearch['flight' + (i + 1) + 'Time'].$modelValue;
    let flightDateTime = moment(flightDate + flightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format(DATE_FORMAT_API);

    let destination = searchForm.flightSearch['flight' + (i + 1) + 'Arrival'].$modelValue;
    let destinationCode = destination.Value;
    let destinationName = destination.City + ', ' + destination.Country;
    let originCode = searchForm.flightSearch['flight' + (i + 1) + 'Departure'].$modelValue.Value;
    return {
      Origin: {
        Code: originCode,
      },
      Destination: {
        Code: destinationCode,
      },
      Date: flightDateTime,
    };
  }
  function addFlight(searchParams, dateTime, originCode, destinationCode) {
    searchParams.search.Flights = searchParams.search.Flights || [];
    searchParams.search.Flights.push({
      Origin: {
        Code: originCode,
      },
      Destination: {
        Code: destinationCode,
      },
      Date: dateTime,
    });

    return searchParams;
  }
  /**
   * Purpose of this function is to create a single Hotel object, adding it to the searchParams object
   * the Hotel object maps to the TravelCTMOBT.Api.Models.*.SearchHotel model in the back end
   * @param {*} searchParams
   * @param {*} checkIn
   * @param {*} checkOut
   * @param {*} location
   */
  function addHotel(searchParams, checkIn, checkOut, location) {
    searchParams.search.Hotels = searchParams.search.Hotels || [];

    let hotelPayload = generateHotelSearchPayload(checkIn, checkOut, location, null);
    searchParams.search.Hotels.push(hotelPayload);

    return searchParams;
  }
  function addCar(searchParams, searchObject) {
    searchParams.search.Cars = searchParams.search.Cars || [];
    searchParams.search.Cars.push(searchObject);

    return searchParams;
  }
  function addGround(searchParams, searchObject) {
    searchParams.search.GroundTransports = searchParams.search.GroundTransports || [];
    searchParams.search.GroundTransports.push(searchObject);

    return searchParams;
  }
  function prepRailFormData(searchForm, searchParams) {
    searchParams.search.Rails = [
      convertRailData({
        railFrom: searchForm.railFrom1,
        railTo: searchForm.railTo1,
        date: searchForm.outboundDate,
        time: searchForm.outboundTime,
        openReturn: searchForm.openReturn,
        railCardCode: searchForm.railCardCode,
      }),
    ];

    if (searchForm.railReturn.$modelValue) {
      searchParams.search.Rails.push(
        convertRailData({
          railFrom: searchForm.railFrom2,
          railTo: searchForm.railTo2,
          date: searchForm.returnDate,
          time: searchForm.returnTime,
          openReturn: searchForm.openReturn,
          railCardCode: searchForm.railCardCode,
        })
      );
    }

    return searchParams;
  }
  function convertRailData(railInfo) {
    let DATE_FORMAT_MEDIUM = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM).replace(',', '[,]');
    let fromLocationText = getRailLocationName(railInfo.railFrom.$modelValue),
      toLocationText = getRailLocationName(railInfo.railTo.$modelValue),
      fromCity = '',
      toCity = '';

    let fromCountryCode = '',
      fromCountryName = '',
      toCountryCode = '',
      toCountryName = '',
      fromCode = '',
      toCode = '';

    if (railInfo.railFrom.$modelValue.City) {
      fromCity = railInfo.railFrom.$modelValue.City.Name;
    }

    if (railInfo.railTo.$modelValue.City) {
      toCity = railInfo.railTo.$modelValue.City.Name;
    }

    if (railInfo.railFrom.$modelValue.Country) {
      fromCountryCode = railInfo.railFrom.$modelValue.Country.Code;
      fromCountryName = railInfo.railFrom.$modelValue.Country.Name;
    }

    if (railInfo.railTo.$modelValue.Country) {
      toCountryCode = railInfo.railTo.$modelValue.Country.Code;
      toCountryName = railInfo.railTo.$modelValue.Country.Name;
    }

    if (railInfo.railFrom.$modelValue.Iata) {
      fromCode = railInfo.railFrom.$modelValue.Iata;
    } else {
      fromCode = railInfo.railFrom.$modelValue.Code;
    }

    if (railInfo.railTo.$modelValue.Iata) {
      toCode = railInfo.railTo.$modelValue.Iata;
    } else {
      toCode = railInfo.railTo.$modelValue.Code;
    }

    let from = {
      Code: fromCode,
      City: fromCity,
      Country: fromCountryName,
      CountryCode: fromCountryCode,
      Location: fromLocationText,
    };

    let to = {
      Code: toCode,
      City: toCity,
      Country: toCountryName,
      CountryCode: toCountryCode,
      Location: toLocationText,
    };

    let date = `${railInfo.date.$modelValue} ${railInfo.time.$modelValue}`;
    let dateParsed = moment(date, DATE_FORMAT_MEDIUM + TIME_FORMAT).format(DATE_FORMAT_API);

    let railCardCode = null;
    let openReturn = railInfo.openReturn.$modelValue;

    if (railInfo.railCard && railInfo.railCard.$modelValue) {
      railCardCode = railInfo.railCard.$modelValue.InternalCode;
    }

    var result = {
      Origin: from,
      Destination: to,
      Date: dateParsed,
      RailCardCode: railCardCode,
      OpenReturn: openReturn,
    };

    return result;
  }
  function getRailLocationName(location) {
    if (location.Title) return location.Title;
    if (location.Description) return location.Description;
    if (location.City && location.City.Name) {
      let val = location.City.Nam;
      if (location.Name) {
        val += ' - ' + location.Name;
      }
      return val;
    }
    if (location.Name) return location.Name;

    return location.Title;
  }

  function prepGroundFormData(searchForm) {
    const pickUpDateTime = dateTimeService.getDateTimeFromDateAndTime(
      searchForm.pickUpDateBlackCar.$modelValue,
      searchForm.pickUpTimeBlackCar.$modelValue
    );

    let routes = _.map(
      _.filter(searchForm.locationsBlackCar.$modelValue, (location) => location.value && !location.value.asDirected),
      (location) => {
        let loc = {
          type: 'Address',
          street: location.value.Address,
          town: location.value.City ? location.value.City.Name : null,
          country: location.value.Country ? location.value.Country.Code : null,
          latitude: location.value.Latitude,
          longitude: location.value.Longitude,
          county:
            location.value.State && location.value.State.Code
              ? location.value.State.Code
              : location.value.State && location.value.State.Name
              ? location.value.State.Name
              : null,
          PostalCode: location.value.PostalCode,
          buildNumber: location.buildNumber,
          isPrivateCarrier: location.value.Type === 'Airport' ? location.isPrivateCarrier : false,
          GooglePlaceId: location.value.GooglePlaceId,
        };

        if (location.value.Type === 'Airport' || loc.isPrivateCarrier) {
          const flightDateTime = dateTimeService.getDateTimeFromDateAndTime(searchForm.pickUpDateBlackCar.$modelValue, location.flightTime);

          loc.type = 'Airport';
          loc.airport = location.value.Iata;
          loc.airline = location.carrierCode;
          loc.flightNumber = location.flightNumber;
          loc.flightDateTime = flightDateTime;
        }
        if (location.value.Type === 'RailStation') {
          const flightDateTime = dateTimeService.getDateTimeFromDateAndTime(searchForm.pickUpDateBlackCar.$modelValue, location.flightTime);

          loc.type = 'TrainStation';
          loc.trainStation = location.value.Iata;
          loc.trainCarrier = location.carrierCode;
          loc.trainNumber = location.flightNumber;
          loc.trainDateTime = flightDateTime;
        }

        return loc;
      }
    );

    return {
      passengerCount: searchForm.passengerCountBlackCar.$modelValue,
      vehicleTypes: searchForm.typeBlackCar.$modelValue,
      startDateTime: pickUpDateTime.format(),
      route: routes,
      asDirectedDuration: _.some(searchForm.locationsBlackCar.$modelValue, (location) => location.value && location.value.asDirected)
        ? searchForm.asDirectedDuration.$modelValue
        : null,
    };
  }
  function parseDateTime(dateValue, timeValue) {
    const date = moment.utc(dateValue);
    const time = moment(timeValue);
    date.millisecond(time.millisecond());
    date.second(time.second());
    date.minute(time.minute());
    date.hour(time.hour());
    return date;
  }

  return service;
};

searchFormService.$inject = $inject;

export default searchFormService;



// WEBPACK FOOTER //
// ./src/services/searchFormService.js